module.exports = __webpack_public_path__ + "img/sef-logo.205aeddc.png";